<template>
  <div
    v-if="saving"
    class="absolute w-14 h-14
        rounded-full cursor-pointer
        bg-pink-600 hover:shadow-pink text-white
        flex items-center justify-center"
  >
    <span class="h-6 w-6 spinner spinner-save" />
  </div>
  <div
    v-else
    class="absolute w-14 h-14
        rounded-full cursor-pointer
        bg-pink-600 hover:shadow-pink text-white
        flex items-center justify-center"
    @click="$emit('save')"
  >
    <icon
      name="save"
      class="h-6 w-6"
    />
  </div>
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon
  },

  props:{
    saving:{
      type: Boolean,
      required: false,
      default: false,
    }
  }

};
</script>
